import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import Reveal from "@/components/marketing/Reveal";

export default function PackagesBridge() {
  return (
    <section className="bg-[#f7f7f9] py-8 sm:py-10">
      <Container className="text-center">
        <Reveal>
        <p className="text-[#3a3646] text-[15px] leading-[1.7] mb-4">
          Need something these do not cover? Our channels are all available individually.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/services/find-your-fit"
            className="text-[#7200CB] font-semibold text-[15px] hover:text-[#14121c] transition-colors"
          >
            Find your fit →
          </Link>
          <span className="w-px h-4 bg-[#e8e6ef]" />
          <Link
            to="/"
            className="text-[#7200CB] font-semibold text-[15px] hover:text-[#14121c] transition-colors"
          >
            Browse all channels →
          </Link>
        </div>
        </Reveal>
      </Container>
    </section>
  );
}